import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const PermissionRequestCover = ({ notification, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  const content = rtl
    ? `يطلب ${sender?.name} إذناَ لعرض فكرتك`
    : `${sender?.name} asks for access permission for your idea`
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={content}
    />
  )
}

export default PermissionRequestCover
